import React from 'react';
import '../App.scss';
import photographerImage from '../assets/photographer.jpg';

const Photographer = () => {
  return (
    <section className="photographer page-section">
      <span className="section-label">Valokuvaaja</span>
      <h1 className="section-heading">Lennart Takanen</h1>
      <p className="section-subtitle">
        Luova teknikko ja suunnittelija, joka yhdistää mainostoimistotaustan, ohjelmointiosaamisen ja yli 20 vuoden kuvauskokemuksen.
        Työstän projektit henkilökohtaisesti, jotta lopputulos on sekä visuaalisesti kunnianhimoinen että käytännöllisesti tehokas.
      </p>
      <div className="photographer-content">
        <img src={photographerImage} alt="Photographer" className="photographer-image" />
        <div className="photographer-text">
          <p>
            Minulla on ollut ilo työskennellä vuosina 1998–2001 huippumainostoimistoissa, kuten TBWA:ssa, yhdessä alan arvostettujen ammattilaisten kanssa.
            Tämä ajanjakso toimi perustana uralleni suunnittelijana ja valokuvaajana.
          </p>
          <p>
            Vuodesta 2002 vuoteen 2012 johdin omaa yritystäni suunnittelijana, ohjelmoijana ja kuvaajana. Canon 5D Mark II avasi uusia ovia
            ja syvensi intohimoani kuvata tarinoita eri formaateissa.
          </p>
          <p>
            Olen työskennellyt video- ja kamera-assistenttina sekä kuvaajana useissa mittavissa tuotannoissa. Opinnot kentällä ovat opettaneet
            yhdistämään luovuuden ja teknologian saumattomasti.
          </p>
          <p>
            Tavoitteeni on ylittää asiakkaiden odotukset jokaisessa projektissa ja rakentaa pitkäkestoisia kumppanuuksia.
            Otan vastaan haastavat briefit ja päivitän niiden visuaalisen ilmeen tulevaisuutta kestäväksi.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Photographer;
